<template>
  <div class="groupings-index-view">
    <page-header :breadcrumbs="breadcrumbs">
      <template #topbar>
        <h1>{{ title }}</h1>
      </template>
    </page-header>
    <div
      v-if="(categories || []).length > 0"
      class="list-container"
    >
      <router-link
        v-for="cat in categories"
        :key="cat.id"
        class="row"
        :to="categoryRoute(cat)"
      >
        {{ cat.name }}
        <icon
          class="arrow-icon"
          name="arrow"
          variant="mastery"
        />
      </router-link>
    </div>
    <div
      v-else
      class="list-container"
    >
      <grouping-list-row
        v-for="grouping in groupings"
        :key="grouping.id"
        :category="category"
        :grouping="grouping"
        @row-clicked="handleRowClick(grouping)"
      />
    </div>
  </div>
</template>

<script>
import InteractiveCaseStudy from '@/classes/interactiveCaseStudy';
import GroupingListRow from '@/components/groupings/listRow';
import Icon from '@/components/singletons/icon';
import PageHeader from '@/components/singletons/pageHeader';
import GlobalMixin from '@/mixins/global';


export default {
  name: 'GroupingsIndexView',
  components: { GroupingListRow, Icon, PageHeader },
  mixins: [GlobalMixin],
  computed: {
    breadcrumbs() {
      const breadcrumbs = [];
      if (this.parentCategories?.length > 0) {
        this.parentCategories.forEach(cat => {
          breadcrumbs.push({
            name: cat.name,
            route: this.categoryRoute(cat),
          });
        });
      } else if (this.category) {
        breadcrumbs.push(this.category.name);
      }
      return breadcrumbs;
    },
    category() {
      if (this.$route.params.categoryId) {
        return this.$store.getters['categories/categories'][this.$route.params.categoryId];
      }
    },
    categories() {
      if (this.category) {
        return this.$store.getters['categories/all'].filter(cat => cat.parentCategoryId === this.category.id);
      } else if (this.currentResource?.resourceId) {
        const catType = this.$store.getters['categoryTypes/categoryTypes'].find(ct => ct.id === this.currentResource.resourceId);
        return this.$store.getters['categories/all'].filter(cat => cat.categoryTypeId === catType.id);
      } else {
        const catTypes = [
          ...this.$store.getters['categoryTypes/groupingCategoryTypes'],
          ...this.$store.getters['categoryTypes/icsCategoryTypes'],
        ].map(ct => ct.id);
        return this.$store.getters['categories/all'].filter(c => catTypes.includes(c.categoryTypeId));
      }
    },
    groupings() {
      let groupings = [];
      let categoryIds = [];
      if (this.category) {
        categoryIds.push(this.category.id);
        groupings = this.$store.getters['groupings/list'].filter(g => g.categoryIds.includes(this.category.id));
      } else if (this.categories?.length > 0) {
        categoryIds = this.categories.map(c => c.id);
        groupings = this.$store.getters['groupings/list'].filter(g => g.categoryIds.some(catId => categoryIds.includes(catId)));
      }

      return groupings.sort((a, b) => {
        let aOrder = a.categoryOrder(categoryIds);
        let bOrder = b.categoryOrder(categoryIds);
        return aOrder - bOrder;
      });
    },
    parentCategories() {
      if (this.category) {
        return this.category.path.split('.').map(catId => this.$store.getters['categories/categories'][catId]).filter(c => c);
      }
    },
    title() {
      if (this.category) {
        return this.category.name;
      } else if (this.currentResource) {
        return this.currentResource.name;
      } else {
        return 'Groupings';
      }
    },
  },
  created() {
    this.$store.dispatch('flashcardStates/fetchStates', ['bookmarks', 'flashcards', 'topics']);
  },
  methods: {
    categoryRoute(cat) {
      return {
        name: 'groupings#index',
        params: {
          categoryId: cat.id,
        },
        query: this.currentQuery,
      };
    },
    handleRowClick(grouping) {
      if (grouping instanceof InteractiveCaseStudy) {
        this.$router.push({
          ...grouping.route,
          query: this.currentQuery,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.groupings-index-view {
  background: #EDF1F5;
  scroll-behavior: smooth;
  @include full-padding;

  .list-heading {
    display: flex;
    color: #7f8fa4;

    .ics-title-heading {
      flex: 1;
    }

    .completed-heading {
      width: rem-calc(200);
    }
  }

  .arrow-icon {
    height: rem-calc(16);
    margin-left: auto;
  }
}
</style>
